const { setoresFormatado } = require('@/utils/ma/setor').default

const CODIGOS_SETORES_FILTRO = [
  'DATGL',
  'CTRU',
  'COMISSAO_ILHA',
  'PRESIDENCIA',
  'GABINETE',
  'GESTAO_SICARF',
  'DUF'
]

const SITUACOES_FILTRO = [
  { codigo: 'AGUARDANDO_ANALISE_DOCUMENTAL', nome: 'Aguardando análise documental' },
  { codigo: 'EM_ANALISE_DOCUMENTAL', nome: 'Em análise documental' },
  { codigo: 'AGUARDANDO_PLANTA_MEMORIAL', nome: 'Aguardando Planta e Memorial' },
  { codigo: 'AGUARDANDO_ANALISE_MALHA_FUNDIARIA', nome: 'Aguardando análise da malha fundiária' },
  { codigo: 'EM_ANALISE_MALHA_FUNDIARIA', nome: 'Em análise da malha fundiária' },
  { codigo: 'AGUARDANDO_EMISSAO_TITULO', nome: 'Aguardando emissão do título' },
  { codigo: 'EM_EMISSAO_TITULO', nome: 'Em emissão do título' },
  { codigo: 'AGUARDANDO_CONFERENCIA_TITULO', nome: 'Aguardando conferência do título' },
  { codigo: 'EM_CONFERENCIA_TITULO', nome: 'Em conferência do título' },
  { codigo: 'AGUARDANDO_IMPRESSAO_TITULO', nome: 'Aguardando impressão do título' },
  { codigo: 'FINALIZADO', nome: 'Finalizado' },
  { codigo: 'AGUARDANDO_ENTREGA_TITULO', nome: 'Aguardando entrega do título' },
  { codigo: 'EM_ENTREGA_TITULO', nome: 'Em entrega de título' },
  { codigo: 'AGUARDANDO_CALCULO_VTN', nome: 'Aguardando cálculo do VTN' },
  { codigo: 'EM_CALCULO_VTN', nome: 'Em cálculo do VTN' },
  { codigo: 'AGUARDANDO_ASSINATURA', nome: 'Aguardando assinatura' },
  { codigo: 'PROCESSANDO_ASSINATURA', nome: 'Processando assinatura' },
  { codigo: 'TITULO_CANCELADO', nome: 'Título cancelado' }
]

export function listarSetoresFiltroExportacaoPlantaMemorial () {
  return CODIGOS_SETORES_FILTRO.map((codigo) => ({
    codigo,
    nome: setoresFormatado[codigo] || codigo
  }))
}

export function listarSituacoesFiltroExportacaoPlantaMemorial () {
  return SITUACOES_FILTRO.map((s) => ({ ...s }))
}



// WEBPACK FOOTER //
// ./src/utils/ma/exportacaoPlantaMemorialComissaoFiltros.js